import script from "./PriceListDateHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceListDateHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PriceListDateHeader.vue?vue&type=style&index=0&id=90b6f056&lang=scss"

const __exports__ = script;

export default __exports__